import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Section, LoadingIcon, Button } from '@prosolve/common-components-ui'
import { FaRegCalendar, FaRegClock, FaWhmcs } from 'react-icons/fa';
import ImagePlaceholder from '../../images/image-placeholder.jpg';
import SessionBlueprint from './SessionTabContent/SessionBlueprint';
// import Tabs from '../sharedComponents/Tabs';
// import SessionResourcesAndSupplies from './SessionTabContent/SessionResourcesAndSupplies';
// import SessionsFacilitatorDetails from './SessionTabContent/SessionsFacilitatorDetails';
// import SessionsModuleRatings from './SessionTabContent/SessionsModuleRatings';
import useIsMobileView from "../../hooks/useIsMobileView";
import EditSessionModal from './EditSessionModal';
import { checkHasEventTrainerPermissions, checkHasEditEventPermissions, getClientSubdomain, isStarConsultation } from '../../utils';
import useDataSessions from '../../dataHooks/useDataSessions';
import useDataEvents from '../../dataHooks/useDataEvents';

export default () => {
  const isMobileView = useIsMobileView();

  const urlParams = new URLSearchParams(window.location.search);
  const sessionId = urlParams.get('id');

  const clientSubdomain = getClientSubdomain()
    
  const isStarSubdomain = (clientSubdomain === 'star')

  const [isLoading, setIsLoading] = useState(true)
  const [sessionData, setSessionData] = useState({});
  const [eventData, setEventData] = useState({});

  const hasEventTrainerPermissions = checkHasEventTrainerPermissions()
  const hasEditPermissions = checkHasEditEventPermissions();

  const hasSessionBlueprintPermissions = (hasEventTrainerPermissions || hasEditPermissions)

  const { fetchSession } = useDataSessions();
  const { fetchEvent } = useDataEvents();

  const fetchSessionData = async () => {
    setIsLoading(true)
    try {
      const session = await fetchSession(sessionId) || {}
      setSessionData(session)

      if (isStarSubdomain) {
        const event = await fetchEvent(session.eventId) || {}
        setEventData(event)
      } else {
        setEventData({})
      }

    } catch (e) {
      setSessionData({})
      setEventData({})
    }
    setIsLoading(false)
  }

  useEffect(() => {
    if (sessionId) {
      fetchSessionData()
    } else {
      // Below is used for when url may be hit without an id provided in the url
      setIsLoading(false)
      setSessionData({})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId])

  const {
    // id = '',
    name = '',
    startTime = '',
    endTime = '',
    date = '',
    image = '',
    description = '',
    learningOutcomes = '',
    location = '',
    trainerLeadName = '',
    schoolName = '',
    address = '',
    teacherName = '',
    teacherEmail = '',
    notes = '',
    classroomType = '',
  } = sessionData;

  const formatDate = () => {
    return moment(date).format('MMMM DD, YYYY');
  }

  const formatTimes = () => {
    const start = moment(startTime, 'hh:mm:ss').format('h:mm A');
    const end = moment(endTime, 'hh:mm:ss').format('h:mm A');
    return `${start} - ${end}`;
  }

  const formatDescription = () => {
    return (description 
      ? <div dangerouslySetInnerHTML={{__html: description}} /> 
      : <div>No description available</div>
    )
  }

  const formatLearningOutcomes = () => {
    return (learningOutcomes 
      ? <div dangerouslySetInnerHTML={{__html: learningOutcomes}} /> 
      : <div>No learning objectives available</div>
    )
  }

  // const tabs = [
  //   'Resources & Supplies', 
  //   'Facilitator Details', 
  //   'Module Ratings', 
  // ];

  // const [selectedTab, setSelectedTab] = useState('')

  // const tabContentMap = {
  //   'Resources & Supplies': <SessionResourcesAndSupplies sessionData={sessionData} />,
  //   'Facilitator Details': <SessionsFacilitatorDetails sessionData={sessionData} />,
  //   'Module Ratings': <SessionsModuleRatings sessionData={sessionData} />,
  // }

  /*
   * All tab content is created and built on render...we simply show or hide the display based on the tab selected
   */
  // const getTabContent = () => {
  //   return Object.keys(tabContentMap).map(key => 
  //     <div key={key} style={{ display: (selectedTab === key) ? 'block' : 'none' }}>
  //       {tabContentMap[key]}
  //     </div>
  //   );
  // }
  
  const [editSessionModalData, setEditSessionModalData] = useState()

  const isStarConsultationSession = isStarSubdomain && isStarConsultation(eventData)

  const displayFields = isStarSubdomain 
    ? 
    (
      isStarConsultationSession ?
      [
        {
          name: 'Name of School',
          field: schoolName || ' - '
        },
        {
          name: 'Address',
          field: address || ' - '
        },
        {
          name: 'Name of Teacher',
          field: teacherName || ' - '
        },
        {
          name: 'Teacher Email',
          field: teacherEmail || ' - '
        },
        /*{
          name: 'Trainer',
          field: trainerLeadName || ' - '
        },*/
        {
          name: 'Notes',
          field: notes || ' - '
        },
        {
          name: 'Classroom Type',
          field: classroomType || ' - '
        },
      ]
      :
      []
    )
    : [
      {
        name: 'Location',
        field: location || ' - '
      },
      {
        name: 'Trainer Lead',
        field: trainerLeadName || ' - '
      }
  ]


  return (
    <div style={{
      display: 'flex',
      padding: isMobileView ? '5px' :  '5px 20px', 
      columnGap: '20px'
    }}>
      {
        Boolean(editSessionModalData) &&
        <EditSessionModal
          sessionData={editSessionModalData}
          isStarConsultationSession={isStarConsultationSession}
          onClose={() => setEditSessionModalData(undefined)}
          onSuccess={() => {
            fetchSessionData()
            setEditSessionModalData(undefined)
          }}
        />
      }
      {
        isLoading ?
        <div style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          height: '650px'
        }}>
          <div style={{ marginTop: '40px' }}>
            <LoadingIcon />
          </div>
        </div>
        :
        <Section style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: '20px' }}>
          {/* <div style={{
            height: '200px',
            position: 'relative',
            background: '#ffffff',
          }}>
            <img 
              style={{ 
                height: '100%', 
                borderTopLeftRadius: '5px', 
                borderBottomLeftRadius: '5px',
                objectFit: 'cover',
                objectPosition: 'top center'
              }} 
              src={image || ImagePlaceholder} 
              alt='eventImage' 
            />
            <div style={{
              position: 'absolute',
              bottom: '0px',
              // width: '100%',
              color: '#ffffff',
              background: '#16171B',
              borderRadius: '10px',
              padding: '6px 10px',
              boxSizing: 'border-box',
              display: 'flex',
              alignItems: 'center'
            }}>
              <FaRegClock style={{ marginRight: '5px' }} />
              {formatTimes()}
            </div>
          </div>
          <div style={{
            fontSize: '18px',
            fontWeight: 'bold',
            marginTop: '5px',
            overflow: 'hidden'
          }}>
            {name}
          </div> */}
          <div
            style={{
              display: 'flex',
              flexDirection: isMobileView ? 'column' : 'row',
              padding: '20px'
            }}
          >
            <div style={{
              padding: '20px',
              paddingRight: isMobileView ? '20px' : '0px'
            }}>
              <img style={{ width: isMobileView ? '100%' : 'auto', height: isMobileView ? 'auto' : '300px', borderRadius: '5px' }} src={image || ImagePlaceholder} alt='eventImage' />
            </div>
            <div style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              padding: '20px'
            }}>
              <div style={{
                display: 'flex',
                flexDirection: isMobileView ? 'column': 'row',
                rowGap: '10px',
                alignItems: isMobileView ? 'flex-start' : 'center',
                paddingTop: isMobileView ? '10px' : '0px'
              }}>
                <div style={{
                  fontWeight: 'bold',
                  fontSize: '16px',
                  color: '#565656',
                  display: 'flex',
                  alignItems: 'center',
                  marginRight: '20px'
                }}>
                  <FaRegCalendar style={{ marginRight: '5px' }} />
                  {formatDate()}
                </div>
                <div style={{
                  fontWeight: 'bold',
                  fontSize: '16px',
                  color: '#565656',
                  display: 'flex',
                  alignItems: 'center'
                }}>
                  <FaRegClock style={{ marginRight: '5px' }} />
                  {formatTimes()}
                </div>
              </div>
              <div style={{
                fontSize: '28px',
                fontWeight: 'bold',
                marginTop: '5px'
              }}>
                {name}
              </div>
              <div style={{
                marginTop: '20px',
                color: '#565656',
              }}>
                {formatDescription()}
              </div>
              <div style={{
                marginTop: '20px',
                // color: '#565656',
                fontSize: '24px',
                fontWeight: 'bold',
                marginBottom: '20px'
              }}>
                Learning Objectives
              </div>
              <div style={{
                color: '#565656',
              }}>
                {formatLearningOutcomes()}
              </div>
              {
                hasEditPermissions && (displayFields.length > 0) &&
                <div style={{ display: 'flex', justifyContent: 'right' }}>
                  <Button
                    style={{
                      display: 'inline-flex',
                      flexDirection: 'column',
                      width: '65px',
                      padding: '2px 0px',
                      border: 'none',
                      textAlign: 'center'
                    }}
                    onClick={() => setEditSessionModalData(sessionData)}
                  >
                    <FaWhmcs style={{ marginBottom: '2px', color: '#0280c6', fontSize: '18px' }} />
                    <span style={{ color: '#565656', fontSize: '14px' }}>{'Edit'}<br />{'Session'}</span>
                  </Button>
                </div>
              }
            </div>
          </div>
          {/* 
            <Tabs tabs={tabs} selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
            {getTabContent()} 
          */}
          {
            hasSessionBlueprintPermissions &&
            <SessionBlueprint sessionData={sessionData} />
          }
          {
            displayFields.length > 0 &&
            <div style={{
              display: 'flex',
              paddingLeft: '20px',
              borderBottom: '1px solid #C2C9D1',
              marginBottom: '20px'
            }}></div>
          }
          {
            displayFields.map(({ name, field }) => (
              <>
                <div style={{
                  flex: 1,
                  color: '#565656',
                  fontSize: '24px',
                  fontWeight: 'bold',
                  marginLeft: '20px'
                }}>
                  {name}
                </div>
                <div style={{
                  color: '#565656',
                  padding: '20px'
                }}>
                  {field}
                </div>
              </>
            ))
          }
        </Section>
      }
    </div>
  )
}